export default {
    getGroupData: function(state) {
        return state.groupData;
    },
    getOperations: function(state) {
        return state.operations;
    },
    getOtherOperations: function(state) {
        return state.otherOperations;
    },
    getDepartments: function(state) {
        return state.departments;
    },
    getDepartmentTransfers: function(state) {
        return state.departmentTransfers;
    },
    getModalContext: function(state) {
        return state.modalContext;
    },
    getLastGroupData: function(state) {
        return state.lastGroup;
    },
    getSource: function(state) {
        return state.source;
    },
    getDefaultCurrency: function(state) {
        return state.defaultCurrency;
    },
    getReturnUrl: function(state) {
        return state.returnUrl;
    },
    getAddContractorsUrl: function(state) {
        return state.addContractorsUrl;
    },
    getMethod: function(state) {
        return state.method;
    },
    getGroupErrors(state) {
        return state.errors;
    },
    getUseExchangeRates(state) {
        return state.useExchangeRates;
    },
    getHasOperationDrafts(state) {
        return state.hasOperationDrafts;
    },
    getOperationDraftsUrl(state) {
        return state.operationDraftsUrl;
    },
    getStatementFiles(state) {
        return state.statementFiles;
    },
    getStatementPdfUploadUrl(state) {
        return state.statementPdfUploadUrl;
    },
    getCanAddStatementPdf(state) {
        return state.canAddStatementPdf;
    },
    getModalCheckboxes(state) {
        return (operationId) => state.modalCheckboxes[operationId] ? state.modalCheckboxes[operationId] : {documents: []};
    },
    getStateToCommit(state) {
        return state.stateToCommit;
    },

    getDynamicContent(state){
        return state.dynamicContent
    },
    getIndexOfDocumentAllocation(state) {
        // const content = this.$store.getters.getDynamicContent
        return allocationToFind => state.modalContext.documentPayments.findIndex(allocation => {
            return allocationToFind.operation_id == allocation.operation_id
                && allocationToFind.allocation_id == allocation.allocation_id;
        });
    },
    getIndexOfDepartmentAllocation(state) {
        // const content = this.$store.getters.getDynamicContent
        return allocationToFind => state.modalContext.departmentTransfers.findIndex(allocation => {
            return allocationToFind.operation_id == allocation.operation_id
                && allocationToFind.allocation_id == allocation.allocation_id;
        });
    }
}
